import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import "swiper/css/bundle";
import "swiper/css";

import Netflix from "../../../assets/logo/netflix.svg";
import HBO from "../../../assets/logo/hbo.svg";
import HULU from "../../../assets/logo/hulu.svg";
import PrimeVideo from "../../../assets/logo/primevideo.svg";

const Index = () => {
  const companyList = [Netflix, HBO, HULU, PrimeVideo, HULU, Netflix, HBO];
  return (
    <>
      <div className="py-24">
        <Swiper
          className=""
          spaceBetween={24}
          slidesPerView={2}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          breakpoints={{
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 2,
              spaceBetween: 21,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: 21,
            },
            // when window width is >= 1024px
            1024: {
              slidesPerView: 4,
              spaceBetween: 21,
            },
            // when window width is >= 1440px
            1440: {
              slidesPerView: 5,
              spaceBetween: 21,
            },
          }}
        >
          {companyList.map((companey, index) => (
            <SwiperSlide
              key={index}
              className="flex items-center justify-center"
            >
              <div className="border border-slate-100 rounded-xl px-12">
                <img className="object-cover w-32" src={companey} alt="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default Index;
